<div class="mr-xsmall-t">
  <div class="flex border rounded-large white-bg overflow-hidden relative">
    <fcom-badge [variant]="BadgeVariant.ROUNDED_TOP_LEFT">{{ 'MMB.upsell.badge' | finLocalization }}</fcom-badge>
    <div class="flex-1 flex--basis0 relative">
      <fcom-image
        *ngIf="article$ | finMap: 'picture' | async as picture"
        class="picture block rounded-top-large border-top border-left border-right border"
        [ratio]="'4x3'"
        [fillParent]="true"
        [scale]="false"
        [imageData]="picture"
      ></fcom-image>
    </div>
    <div class="flex-1 flex--basis0 ps-medium">
      <div class="pr-small-b" [innerHTML]="article$ | finMap: 'teaserText' | async"></div>
      <fcom-button
        *ngIf="service.upsell.showButton$ | async; else loading"
        [icon]="{ category: 'svg-library', name: 'plus', position: IconPosition.RIGHT }"
        [text]="'MMB.upsell.seat.buttonText' | finLocalization"
        [mode]="ButtonMode.FILL"
        (click)="upsellClicked.emit(service.category)"
      ></fcom-button>
      <ng-template #loading
        ><div class="fill flex flex--center"><fin-loader [type]="LoaderType.INLINE_TEXT"></fin-loader></div
      ></ng-template>
    </div>
  </div>
</div>
